import script from "./ComingIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComingIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./ComingIndicator.vue?vue&type=style&index=0&id=1971c5c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1971c5c2"]])

export default __exports__